import { useGetList } from './useGetList'
import { useGetMetrics } from './useGetMetrics'
import { useReorder } from './useReorder'

export const trainingModules = {
  reorder: useReorder,
  getMetrics: useGetMetrics,
  getList: useGetList,
}
